export enum ContactApiRoutes {
  ContactCurrentSession = '/contacts/current-session',
  CallDetails = '/contacts/call-details',
  RecentAIVendorInteraction = '/contacts/:id/recent-aivendor-interaction',
  CallPreview = '/contacts/leads/:id/preview',
  PostSaleSurvey = '/contacts/:id/post-sale-survey',
  ContactSessionEvents = '/contacts/sessions/:id/events',
  ContactMaskCall = '/contacts/:id/sessions/:id/mask',
  ContactUnmaskCall = '/contacts/:id/sessions/:id/unmask',
}
